import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { ProjectCard } from "./ProjectCard";

export default function LatestWorks() {
  const { projects } = useSite();
  const featured = projects.filter((p) => p.featured);
  const list = (featured.length ? featured : projects).slice(0, 3);
  return (
    <section id="projects" data-testid="latest-works-section" className="py-20 md:py-24 scroll-mt-16">
      <div className="container-lm">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <p className="eyebrow">Seçilmiş layihələr</p>
            <h2 className="font-display text-3xl sm:text-4xl font-semibold mt-4">Son işlərimiz</h2>
            <p className="text-sm text-[#77736B] mt-4 max-w-md leading-relaxed">
              Bizim üçün hər layihə yeni bir hekayədir. Aşağıda müştərilərimiz üçün hazırladığımız və hazırda fəaliyyətdə olan real layihələrlə tanış ola bilərsiniz.
            </p>
          </div>
          <Link to="/layiheler" className="link-arrow" data-testid="all-works-link">Bütün işlərə baxın <ArrowRight size={15} className="arr" /></Link>
        </div>
        <div className="grid gap-10 md:gap-6 md:grid-cols-3 mt-12">
          {list.map((p) => <ProjectCard key={p.id} p={p} />)}
        </div>
      </div>
    </section>
  );
}
